import React, { Fragment } from 'react';
import Form from '../../form';
import CommonDataService from '../../../services/CommonDataService';

class RevelationDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      serverLocations: []
    }
  }

  componentDidMount() {
    CommonDataService
      .getServerLocations()
      .then(serverLocations => this.setState({ serverLocations }));
  }

  render() {

    return (
      <Fragment>
        <Form.FieldGroup label="Recruiter Bid">
          <Form.Input
            name="revelation.recruiterBid"
            placeholder="Recruiter's bid" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Purchase Order">
          <Form.Input
            name="revelation.purchaseOrder"
            placeholder="Purchase Order Number" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Incentive amount" className="right to-right">
          <Form.Input
            name="revelation.incentiveSize"
            step="1"
            type="number"
            placeholder="0"
            className="max-320" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Number of boards" className="right to-right">
          <Form.Input
            name="revelation.numberOfBoards"
            step="1"
            type="number"
            placeholder="0"
            className="max-320" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Server Location">
          <Form.Dropdown
            name="revelation.serverLocation"
            options={this.state.serverLocations}
            multi={false} />
          <Form.FieldError name="revelation.serverLocation" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Bulk">
          <Form.Input
            name="revelation.isBulk"
            type="checkbox" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Launch date*" className="right to-right">
          <Form.Datepicker
            name="launchDate" />
          <Form.FieldError name="launchDate" />
        </Form.FieldGroup>

        <Form.FieldGroup label="End date*" className="right to-right">
          <Form.Datepicker
            name="revelation.endDate" />
          <Form.FieldError name="revelation.endDate" />
        </Form.FieldGroup>

        <Form.FieldGroup label="Programming start date*" className="right to-right">
          <Form.Datepicker
            name="startDate" />
          <Form.FieldError name="startDate" />
        </Form.FieldGroup>

      </Fragment>
    );
  }
}

export default RevelationDetails;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectForm/RevelationDetails.js